
  import { reactive } from "vue";
  import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";
  
  export default {
    name: "FailedLoginRegistration",
    inheritAttrs: false,
    components: {
      DynamicForm
    },
    setup() {    
      const request = reactive({
        apiLoadMethod: "api/anonymousForm/loadForm",
        apiSaveMethod: "api/anonymousForm/saveForm",
        form: "FailedLoginRegistration",
        page: "FailedLoginRegistration",
        remoteId: "",
        waitForResponse: true
        
      });
  
      return {
        request
      };
    }
  };
  